
export const getAccountCampaignSummary = {
  GET_ACCOUNT_CAMPAIGN_SUMMARY_REQUEST: "GET_ACCOUNT_CAMPAIGN_SUMMARY_REQUEST",
  GET_ACCOUNT_CAMPAIGN_SUMMARY_SUCCESS: "GET_ACCOUNT_CAMPAIGN_SUMMARY_SUCCESS",
  GET_ACCOUNT_CAMPAIGN_SUMMARY_FAILURE: "GET_ACCOUNT_CAMPAIGN_SUMMARY_FAILURE"
}